import { connect } from 'react-redux'
import CreateContract from './CreateContract'
import * as contractActions from '../ContractsActions'
import * as flashMessageActions from '../../FlashMessage/FlashMessageActions'

const mapStateToProps = (state) => ({
    contract: state.contracts.newContract
})

const actions = {
    ...contractActions, 
    ...flashMessageActions
}

export default connect(mapStateToProps, actions)(CreateContract)


// WEBPACK FOOTER //
// ./src/components/Contracts/Create/index.jsx